import { render, staticRenderFns } from "./field-set.component.vue?vue&type=template&id=005006ce&scoped=true&lang=pug"
import script from "./field-set.component.vue?vue&type=script&lang=ts"
export * from "./field-set.component.vue?vue&type=script&lang=ts"
import style0 from "./field-set.component.vue?vue&type=style&index=0&id=005006ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005006ce",
  null
  
)

export default component.exports